import { EnvConfig } from './env-config';

declare let window: any;

export const environment = {
	...EnvConfig,
	production: true,
	token: typeof window !== 'undefined' ? window.token : '',
	backendUrl: (typeof window !== 'undefined' && window.backendUrl) ? window.backendUrl : (EnvConfig.backendUrl || '')
};
